import { PlusOutlined, PlusSquareOutlined } from "@ant-design/icons"
import { Badge } from "components/Badge/Badge"
import { Button } from "components/Button/Button"
import { type MenuItemType } from "components/Menu/Menu"
import { Space } from "components/Space/Space"

import { useRightSidebar } from "hooks/useRightSidebar"
import { useFlag } from "modules/flags/flags"
import { useParams } from "react-router"
import { useTicketUpdates } from "services/support"
import { useUserRole } from "services/users"

export function useSupportRequests() {
	const { data: { isPatient, isProvider, isFieldSupportAgent } = {} } =
		useUserRole()
	const flags = useFlag("supportRequests")
	const { setSidebarState } = useRightSidebar()
	const { userId: patientId } = useParams()
	const patientUpdates = useTicketUpdates(true, patientId)
	const ownUpdates = useTicketUpdates()

	if (
		!flags.supportRequests.enabled ||
		(!isPatient && !isProvider && !isFieldSupportAgent)
	) {
		return { items: [], ownUpdatesCount: 0 }
	}

	return {
		ownUpdatesCount: ownUpdates.data ?? 0,
		items: [
			{
				key: "support",
				label: "My support tickets",
				icon: <PlusSquareOutlined aria-hidden />,
				itemIcon: (
					<Badge
						count={ownUpdates.data}
						classNames={{ indicator: "ml-2 bg-blue-60" }}
					/>
				),
				className: "flex items-center",
				onClick: () => setSidebarState({ key: "support", onBehalfOf: false }),
			} as MenuItemType,
		],
		button: (
			<Space.Compact>
				<Button
					loading={patientUpdates.isFetching}
					onClick={() =>
						setSidebarState({
							key: "support",
							onBehalfOf: true,
						})
					}
				>
					Patient tickets
					<Badge
						count={patientUpdates.data}
						classNames={{ indicator: "bg-blue-60" }}
					/>
				</Button>
				<Button
					icon={<PlusOutlined aria-hidden />}
					onClick={() =>
						setSidebarState({
							key: "support",
							onBehalfOf: true,
							initializeCreate: true,
						})
					}
				/>
			</Space.Compact>
		),
	}
}
